import React,{ useState } from 'react';
import './HalfPageBreif.css'
import { Globals as OldGlobals } from '../../global/Globals';
import { downloadFile } from '../../services/GenericAPI';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

export default function DocumentItem({ foundDoc, docFor, heading }) {
  const { Globals ,languages, setLanguages } = useLanguage();
    const [isDownloading, setIsDownloading] = useState(false);
  
    const downloadSelectedFile = async (event) => {
      // Prevent the default anchor tag behavior
      if (event) {
        event.preventDefault();
      }
      setIsDownloading(true);
      const filePath = foundDoc?.documentPath;
      const fileName = foundDoc?.documentName;
      const fileExtension = fileName?.split('.').pop();
      try {
        if(docFor === 'TKTDOC') {
          const response = await downloadFile(filePath, true);
          if (response?.data) {
            const blob = new Blob([response.data]);
            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
            setIsDownloading(false);
          } else {
            console.error("Error: No file data available for download.");
            setIsDownloading(false);
          } 
        } else {
            const response = await downloadFile(filePath);
          if (response?.data) {
            let blob;
            if (fileExtension === "pdf" || fileExtension === "PDF") {
              blob = new Blob([response.data], { type: 'application/pdf' });
            }
            else {
              blob = new Blob([response.data]);
            }
            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
    
            link.href = fileUrl;
            link.setAttribute("download", fileName);
            if (fileExtension === "pdf" || fileExtension === "PDF") {
              link.target = "_blank";
              link.rel = "noopener noreferrer";
              document.body.appendChild(link);
              window.open(link, '_blank', 'noopener,noreferrer');
            }
            else {
              document.body.appendChild(link);
              link.click();
            }
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
            setIsDownloading(false);
          } else {
            console.error("Error: No file data available for download.");
            setIsDownloading(false);
          }
        }
      } catch (error) {
        console.error("Error in downloading the file:", error);
        setIsDownloading(false);
      }
    };
    return (
      <div className="file-item" key={foundDoc?.documentId || docFor}>
        <div className="proposal-heading-file">{heading==="Production Schedule"?Globals.UNSOLICITED_PROPOSAL.PITCH_DECK:heading}</div>
        {foundDoc?.documentName && (
          <div
            className="document documentdownload"
            href={"#"}
            onClick={(event) => (!isDownloading ? downloadSelectedFile(event) : null)}
          >
            {isDownloading && (
              <img
                width={16}
                height={16}
                src={OldGlobals.LOADERS.SPINNING_LOADER}
                style={{ marginRight: "5px", verticalAlign: "middle" }}
              />
            )}
            {!isDownloading && (
              <img
                src={OldGlobals.IMG.DOCUMENT}
                alt="Document"
                style={{ marginRight: "5px", verticalAlign: "middle" }}
              />
            )}
            <span>{foundDoc.documentName}</span>
          </div>
        )}
        {!foundDoc?.documentName && (
          <span className="no-document">{Globals.HALFSCREEN.NA}</span>
        )}
      </div>
    );
  }
  